import { Mail, MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/lib/constants";

const CONTACT_EMAIL = "info@legendmagazine.it";

export default function MobileContactBar() {
  const wa = `https://wa.me/39${WHATSAPP_NUMBER}?text=${encodeURIComponent("Ciao Legend Team, vorrei un'informazione")}`;
  const mail = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Richiesta info — Legend Magazine")}`;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] md:hidden grid grid-cols-2 border-t-2 border-legend-ink shadow-[0_-4px_20px_rgba(0,0,0,0.25)]" data-testid="mobile-contact-bar">
      <a href={wa} target="_blank" rel="noreferrer" data-testid="mobile-whatsapp" className="flex items-center justify-center gap-2 bg-[#25D366] text-black font-bold uppercase tracking-wide text-sm py-3 active:brightness-95">
        <MessageCircle size={18} /> WhatsApp
      </a>
      <a href={mail} data-testid="mobile-email" className="flex items-center justify-center gap-2 bg-legend-red text-white font-bold uppercase tracking-wide text-sm py-3 active:brightness-95">
        <Mail size={18} /> Scrivici via email
      </a>
    </div>
  );
}
